import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { getWarmupDomainRules, createWarmupDomainRule, removeWarmupDomainRules } from '../../services/warmupDomains';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress } from '@material-ui/core';
import { Button, InputField, Modal, Text } from '@getpingback/realeza';
import { PlusIcon, TrashCanIcon } from '@stash-ui/regular-icons';

const WarmupDomainsRules = ({ location, match }) => {
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [channelUidValue, setChannelUidValue] = useState('');
  const [positionValue, setPositionValue] = useState('');
  const [percentValue, setPercentValue] = useState('');
  const [isLoadingNewWarmupRule, setIsLoadingNewWarmupRule] = useState(false);

  const [warmupDomainRules, setWarmupDomainRules] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });
  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayWarmupDomainRules(currentPage);
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['id', 'channelUid', 'position', 'percent', 'status', 'createdAt'];
  const SearchBoxHeaders = ['id', 'channelUid'];

  const displayWarmupDomainRules = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: warmupDomainRules } = await getWarmupDomainRules(currentPage || page, params);

      setWarmupDomainRules(warmupDomainRules.rows);
      setTotalItems(warmupDomainRules.count);
      setTotalPages(warmupDomainRules.pages);
      setPage(warmupDomainRules.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const addNewWarmupRule = async () => {
    try {
      setIsLoadingNewWarmupRule(true);

      const percentValueDivided = Number(percentValue) / 100;

      await createWarmupDomainRule(channelUidValue, positionValue, percentValueDivided);
      dispatch(showAlert('success', 'Warmup rule added successfully'));
      setIsLoadingNewWarmupRule(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      setIsLoadingNewWarmupRule(false);
    }
  };

  const deleteWarmupRule = async id => {
    try {
      await removeWarmupDomainRules(id);
      dispatch(showAlert('success', 'Warmup rule removed successfully'));
    } catch (error) {
      console.log(error);
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="users-container">
        <h1>Warmup Domains Rules ({totalItems})</h1>

        <div className="users-right">
          <Button appearence="solid" onClick={() => setIsModalOpen(true)} leftElement={<PlusIcon />}>
            Add warmup rule
          </Button>

          <SearchBox
            date-testid="search-box"
            selectItems={SearchBoxHeaders}
            onSubmitSearch={handleSubmitSearch}
            isSearching={isSearching}
            setIsOrdering={setIsOrdering}
          />
        </div>
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={warmupDomainRules}
        action={false}
        bodyColumn={headers}
        linkPath={'warmup-domains-rules'}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
        customActions={[
          {
            icon: <TrashCanIcon />,
            action: item => {
              deleteWarmupRule(item.id);
            },
          },
        ]}
      />

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Text tag="h2" type="subtitle" size={20} weight="semibold">
          Add warmup rule
        </Text>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <InputField
            label="Channel UID"
            value={channelUidValue}
            onChange={e => setChannelUidValue(e.target.value)}
            placeholder="Enter channel UID"
          />

          <InputField
            label="Position"
            type="number"
            value={positionValue}
            onChange={e => setPositionValue(e.target.value)}
            placeholder="Enter position"
            helperText="Only numbers are allowed"
          />

          <InputField
            label="Percent"
            type="number"
            min="0"
            max="1"
            value={percentValue}
            onChange={e => {
              const number = Number(e.target.value);
              if (number >= 0 && number <= 100) setPercentValue(number.toString());
            }}
            placeholder="Enter percent"
            helperText="Only numbers between 1 and 100 are allowed"
          />
        </div>

        <Button fullWidth appearence="solid" mt="16px" isLoading={isLoadingNewWarmupRule} onClick={addNewWarmupRule}>
          Add
        </Button>
      </Modal>
    </>
  );
};

export default WarmupDomainsRules;
